<template>
  <div>
    <div class="row px-2">
      <div class="col-sm-12">
        <base-input>
          <b-form-checkbox
            v-model="formData.pointsEarning"
            :disabled="viewMode"
            name="check-button"
            switch
          >
            <label class="form-control-label">Points Earning</label>
          </b-form-checkbox>
        </base-input>
        <div v-if="formData.pointsEarning">
          <div class="row">
            <div class="col-sm-4">
              <label class="form-control-label">
                Channels <span class="text-danger">*</span>
              </label>
            </div>
            <div class="col-sm-8">
              <div class="row">
                <base-input class="p-0 m-0">
                  <a-checkbox
                    :disabled="viewMode"
                    v-model="formData.pointsEarningConfig.appNotification"
                  >
                    <label class="form-control-label">App Notification</label>
                  </a-checkbox>
                </base-input>
              </div>
              <div class="row">
                <base-input class="p-0 m-0">
                  <a-checkbox
                    :disabled="viewMode"
                    v-model="formData.pointsEarningConfig.smsNotification"
                  >
                    <label class="form-control-label">SMS Notification</label>
                  </a-checkbox>
                </base-input>
              </div>
            </div>
            <div class="col-sm-12">
              <div
                v-if="
                  $v.formData.pointsEarningConfig.atLeastOneNotification.$dirty
                "
                class="text-danger"
              >
                <div
                  class="error"
                  v-if="
                    !$v.formData.pointsEarningConfig.atLeastOneNotification
                      .required
                  "
                >
                  Please select atleast one channel
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 mb-2">
              <base-input>
                <label class="form-control-label">
                  Title
                  <span
                    class="text-danger"
                    v-if="formData.pointsEarningConfig.appNotification"
                    >*</span
                  >
                </label>
                <a-input
                  v-model="formData.pointsEarningConfig.title"
                  :disabled="viewMode"
                />
                <small>*Not applicable for SMS notification</small>
                <div
                  v-if="$v.formData.pointsEarningConfig.title.$dirty"
                  class="text-danger"
                >
                  <div
                    class="error"
                    v-if="!$v.formData.pointsEarningConfig.title.required"
                  >
                    Field is required
                  </div>
                </div>
              </base-input>
            </div>
            <div class="col-sm-12 mb-2">
              <label class="form-control-label">
                Message <span class="text-danger">*</span>
                <b-button
                  v-if="!viewMode"
                  class="btn btn-link"
                  @click="
                    () => {
                      isRedeem = false;
                      $bvModal.show('code-list-modal');
                    }
                  "
                >
                  ( <u>codes list</u> )
                </b-button>
              </label>
              <a-textarea
                v-model="formData.pointsEarningConfig.message"
                :disabled="viewMode"
                :auto-size="{ minRows: 5, maxRows: 5 }"
              />
              <div
                v-if="$v.formData.pointsEarningConfig.message.$dirty"
                class="text-danger"
              >
                <div
                  class="error"
                  v-if="!$v.formData.pointsEarningConfig.message.required"
                >
                  Field is required
                </div>
              </div>
            </div>

            <div class="col-sm-12 mb-2">
              <label class="form-control-label">
                Header Image
                <br />
                <small>*Not applicable for SMS notification (1280 x 720)</small>
              </label>
              <div class="input-group mb-3">
                <div class="custom-file">
                  <b-form-file
                    v-if="!viewMode"
                    data-var-name="points_earning_image_url"
                    @change="handleFileChangeEarning"
                    accept=".jpg, .jpeg, .png"
                    :placeholder="pointsEarningSelectedFileName"
                  ></b-form-file>
                </div>
              </div>
              <div class="row" v-if="formData.pointsEarningConfig.image_url">
                <div class="col">
                  <base-input label="Image Preview: ">
                    <br />
                    <a-button
                      type="danger"
                      data-var-name="game_image_url"
                      @click="removeImageEarning"
                      block
                      :disabled="viewMode"
                    >
                      <i class="fa fa-trash"> </i> Remove Image
                    </a-button>
                    <br />
                    <img
                      class="img-fluid img-center img-thumbnail"
                      :src="formData.pointsEarningConfig.image_url"
                    />
                  </base-input>
                </div>
              </div>
            </div>
            <div class="col-sm-12 mb-2">
              <base-input label="Sending Time">
                <a-time-picker
                  v-model="formData.pointsEarningConfig.sending_time"
                  use12-hours
                  format="h:mm a"
                  :disabled="viewMode"
                  style="width: 100%"
                />
                <small>*leave blank if notification is real time</small>
              </base-input>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <base-input>
          <b-form-checkbox
            v-model="formData.pointsRedemption"
            :disabled="viewMode"
            name="check-button"
            switch
          >
            <label class="form-control-label">Points Redemption</label>
          </b-form-checkbox>
        </base-input>
        <div v-if="formData.pointsRedemption">
          <div class="row">
            <div class="col-sm-4">
              <label class="form-control-label">
                Channels <span class="text-danger">*</span>
              </label>
            </div>
            <div class="col-sm-8">
              <div class="row">
                <base-input class="p-0 m-0">
                  <a-checkbox
                    :disabled="viewMode"
                    v-model="formData.pointsRedemptionConfig.appNotification"
                  >
                    <label class="form-control-label">App Notification</label>
                  </a-checkbox>
                </base-input>
              </div>
              <div class="row">
                <base-input class="p-0 m-0">
                  <a-checkbox
                    :disabled="viewMode"
                    v-model="formData.pointsRedemptionConfig.smsNotification"
                  >
                    <label class="form-control-label">SMS Notification</label>
                  </a-checkbox>
                </base-input>
              </div>
            </div>

            <div class="col-sm-12">
              <div
                v-if="
                  $v.formData.pointsRedemptionConfig.atLeastOneNotification
                    .$dirty
                "
                class="text-danger"
              >
                <div
                  class="error"
                  v-if="
                    !$v.formData.pointsRedemptionConfig.atLeastOneNotification
                      .required
                  "
                >
                  Please select atleast one channel
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 mb-2">
              <base-input label="Title" required>
                <a-input
                  v-model="formData.pointsRedemptionConfig.title"
                  :disabled="viewMode"
                />
                <small>*Not applicable for SMS notification</small>
                <div
                  v-if="$v.formData.pointsRedemptionConfig.title.$dirty"
                  class="text-danger"
                >
                  <div
                    class="error"
                    v-if="!$v.formData.pointsRedemptionConfig.title.required"
                  >
                    Field is required
                  </div>
                </div>
              </base-input>
            </div>
            <div class="col-sm-12 mb-2">
              <label class="form-control-label">
                Message <span class="text-danger">*</span>
                <b-button
                  class="btn btn-link"
                  v-if="!viewMode"
                  @click="
                    () => {
                      isRedeem = true;
                      $bvModal.show('code-list-modal');
                    }
                  "
                >
                  ( <u>codes list</u> )
                </b-button>
              </label>
              <a-textarea
                v-model="formData.pointsRedemptionConfig.message"
                :disabled="viewMode"
                :auto-size="{ minRows: 5, maxRows: 5 }"
              />
              <div
                v-if="$v.formData.pointsRedemptionConfig.message.$dirty"
                class="text-danger"
              >
                <div
                  class="error"
                  v-if="!$v.formData.pointsRedemptionConfig.message.required"
                >
                  Field is required
                </div>
              </div>
            </div>

            <div class="col-sm-12 mb-2">
              <label class="form-control-label">
                Header Image
                <br />
                <small>*Not applicable for SMS notification</small>
              </label>
              <div class="input-group mb-3">
                <div class="custom-file">
                  <b-form-file
                    v-if="!viewMode"
                    data-var-name="points_redemption_image_url"
                    @change="handleFileChangeRedemption"
                    accept=".jpg, .jpeg, .png"
                    :placeholder="pointsRedemptionSelectedFileName"
                  ></b-form-file>
                </div>
              </div>
              <div class="row" v-if="formData.pointsRedemptionConfig.image_url">
                <div class="col">
                  <base-input label="Image Preview: ">
                    <br />
                    <a-button
                      type="danger"
                      data-var-name="points_redemption_image_url"
                      @click="removeImageRedemption"
                      block
                      :disabled="viewMode"
                    >
                      <i class="fa fa-trash"> </i> Remove Image
                    </a-button>
                    <br />
                    <img
                      class="img-fluid img-center img-thumbnail"
                      :src="formData.pointsRedemptionConfig.image_url"
                    />
                  </base-input>
                </div>
              </div>
            </div>
            <div class="col-sm-12 mb-2">
              <base-input label="Sending Time">
                <a-time-picker
                  v-model="formData.pointsRedemptionConfig.sending_time"
                  :disabled="viewMode"
                  use12-hours
                  format="h:mm a"
                  style="width: 100%"
                />
                <small>*leave blank if notification is real time</small>
              </base-input>
            </div>
          </div>
        </div>
      </div>

      <b-modal id="code-list-modal" hide-footer hide-header>
        <div class="d-block text-center">
          <div class="row">
            <div class="col">
              <h2>Available Codes</h2>
              <hr class="mt-1 mb-1" />
              {customer_name}<br />
              <span v-if="!isRedeem">{points_earned}<br /></span>
              <span v-else>{points_redeemed}<br /></span>
              {updated_points}<br />
              {transaction_date}<br />
            </div>
          </div>
        </div>
        <hr class="mt-1 mb-1" />
        <div class="col">
          <div class="d-flex justify-content-end">
            <b-button
              class="mt-3 float-end w-25 btn-sm"
              variant="primary"
              @click="$bvModal.hide('code-list-modal')"
              >OK
            </b-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';

export default {
  name: 'MembershipProgramNotificationTab',
  props: {
    notificationConfigData: {
      type: Object,
      default: null
    },
    viewMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      codeList: {
        visible: false
      },
      isRedeem: false,
      pointsEarningSelectedFileName: 'Choose a image ...',
      pointsRedemptionSelectedFileName: 'Choose a image ...',
      formData: {
        pointsRedemption: false,
        pointsEarning: false,
        pointsRedemptionConfig: {
          title: null,
          message: null,
          smsNotification: false,
          appNotification: false,
          image: null,
          image_url: null,
          sending_time: null
        },
        pointsEarningConfig: {
          title: null,
          message: null,
          smsNotification: false,
          appNotification: false,
          image: null,
          image_url: null,
          sending_time: null
        }
      }
    };
  },
  validations: {
    formData: {
      pointsRedemptionConfig: {
        title: {
          required: requiredIf(function () {
            return (
              this.formData.pointsRedemption &&
              this.formData.pointsRedemptionConfig.appNotification
            );
          })
        },
        message: {
          required: requiredIf(function () {
            return this.formData.pointsRedemption;
          })
        },
        atLeastOneNotification: {
          required: requiredIf(function () {
            return (
              this.formData.pointsRedemption &&
              !this.formData.pointsRedemptionConfig.appNotification &&
              !this.formData.pointsRedemptionConfig.smsNotification
            );
          })
        }
      },
      pointsEarningConfig: {
        title: {
          required: requiredIf(function () {
            return (
              this.formData.pointsEarning &&
              this.formData.pointsEarningConfig.appNotification
            );
          })
        },
        message: {
          required: requiredIf(function () {
            return this.formData.pointsEarning;
          })
        },
        atLeastOneNotification: {
          required: requiredIf(function () {
            return (
              this.formData.pointsEarning &&
              !this.formData.pointsEarningConfig.appNotification &&
              !this.formData.pointsEarningConfig.smsNotification
            );
          })
        }
      }
    }
  },
  methods: {
    removeImageRedemption() {
      this.pointsRedemptionSelectedFileName = 'Choose a image ...';
      this.formData.pointsRedemptionConfig.image_url = null;
      this.formData.pointsRedemptionConfig.image_url = null;
    },
    removeImageEarning() {
      this.pointsEarningSelectedFileName = 'Choose a image ...';
      this.formData.pointsEarningConfig.image = null;
      this.formData.pointsEarningConfig.image_url = null;
    },
    async handleFileChangeEarning(event) {
      this.formData.pointsEarningConfig.image = [event.target.files[0]];
      const { src } = await this.readFileContent(event.target.files[0]);
      this.formData.pointsEarningConfig.image_url = src;
    },
    async handleFileChangeRedemption(event) {
      this.formData.pointsRedemptionConfig.image = [event.target.files[0]];
      const { src } = await this.readFileContent(event.target.files[0]);
      this.formData.pointsRedemptionConfig.image_url = src;
    },
    readFileContent(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (evt) => {
          const img = new Image();
          img.src = evt.target.result;
          img.onload = () => {
            const desiredAspectRatio = 16 / 9;
            const imageAspectRatio = img.width / img.height;

            let newWidth, newHeight;

            if (imageAspectRatio > desiredAspectRatio) {
              newWidth = img.height * desiredAspectRatio;
              newHeight = img.height;
            } else {
              newWidth = img.width;
              newHeight = img.width / desiredAspectRatio;
            }

            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, newWidth, newHeight);

            const resizedSrc = canvas.toDataURL('image/jpeg');
            resolve({
              src: resizedSrc,
              width: newWidth,
              height: newHeight
            });
          };
        };
        reader.onerror = reject;
      });
    },
    openModal() {
      this.codeList.visible = true;
    },
    closeModal() {
      this.codeList.visible = false;
      this.clearForm();
    },
    setFormData(notificationConfigData) {
      if (
        typeof notificationConfigData !== 'undefined' &&
        notificationConfigData &&
        notificationConfigData.pointsEarningConfig
      ) {
        this.formData = { ...notificationConfigData };
      }
    },
    clearForm() {
      this.formData = {
        pointsRedemption: false,
        pointsEarning: false,
        pointsRedemptionConfig: {
          title: null,
          message: null,
          smsNotification: false,
          appNotification: false,
          image: null,
          sending_time: null
        },
        pointsEarningConfig: {
          title: null,
          message: null,
          smsNotification: false,
          appNotification: false,
          image: null,
          sending_time: null
        }
      };

      this.$v.formData.$reset();
    }
  },

  created() {
    this.setFormData(this.notificationConfigData);
  },

  watch: {
    notificationConfigData: function (data) {
      this.setFormData(data);
    }
  }
};
</script>
